// Matomo Analytics Hook

declare global {
    interface Window {
        _paq: any[];
    }
}

export const useMatomo = () => {
    const trackPageView = (title: string) => {
        if (window._paq) {
            window._paq.push(['setCustomUrl', window.location.href]);
            window._paq.push(['setDocumentTitle', title]);
            window._paq.push(['trackPageView']);
        }
    };

    const trackEvent = (category: string, action: string, name?: string, value?: number) => {
        if (window._paq) {
            window._paq.push(['trackEvent', category, action, name, value]);
        }
    };

    return { trackPageView, trackEvent };
};
